module.exports = __webpack_public_path__ + "img/SketchPng0ac38b4d85af2f8524d4563a4246ee722c4e914898263f4831c296b0ba360043.25af28ce.png";